import { render } from "./sfmc-settings.vue?vue&type=template&id=61611429&scoped=true"
import script from "./sfmc-settings.vue?vue&type=script&lang=js"
export * from "./sfmc-settings.vue?vue&type=script&lang=js"

import "./sfmc-settings.vue?vue&type=style&index=0&id=61611429&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61611429"]])

export default __exports__